import React from 'react';
import { Modal } from 'antd';
import { connect } from 'dva';
import { formItemLayoutModal } from 'utils/utils.js';
import AddBankCardForm from '../../components/AddBankCardForm/Index.js';

@connect(({ merchantBusinessMy }) => ({
  modal: merchantBusinessMy.modal,
}))
export default class EditBankCardModal extends React.Component {
  constructor(props) {
    super(props);

    this.handleHideModal = this.handleHideModal.bind(this);
    this.handleSaveSuccess = this.handleSaveSuccess.bind(this);
  }

  handleHideModal() {
    this.props.dispatch({
      type: 'merchantBusinessMy/toggleModalVisibility',
      modal: { showEditBankCard: false },
    });
  }

  handleSaveSuccess() {
    this.handleHideModal();

    if (this.props.saveSuccessCallback) {
      this.props.saveSuccessCallback();
    }
  }

  render() {
    const { modal: { showEditBankCard } } = this.props;
    if (!showEditBankCard) {
      return null;
    }

    return (
      <Modal title="更换银行卡" visible footer={null} onCancel={this.handleHideModal}>
        <AddBankCardForm
          type="edit"
          itemLayout={formItemLayoutModal}
          saveSuccessCallback={this.handleSaveSuccess}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Merchant/Business/My/Modal/EditBankCard.js